import { useEffect, useState, type ImgHTMLAttributes, type ReactNode } from "react";

interface OptionalImageProps
  extends Omit<ImgHTMLAttributes<HTMLImageElement>, "onError" | "src"> {
  fallback?: ReactNode;
  src: string | null;
}

export function OptionalImage({ fallback = null, src, ...props }: OptionalImageProps) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (!src || failed) return <>{fallback}</>;
  return <img {...props} src={src} onError={() => setFailed(true)} />;
}
